import React, { useContext, useEffect } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Modal } from 'antd';
import useTranslation from '../../hooks/translation/useTranslation';
import { UserContext } from '../../contexts/userContext/userContext';

function ExternalAuth({ type }) {
  const route = useLocation();
  const navigate = useNavigate();
  const { trans } = useTranslation();
  const userContext = useContext(UserContext);

  useEffect(() => {
    axios
      .get(`/api/auth/${type}/redirect${route.search}`)
      .then(async (res) => {
        if (res?.data?.status === 'success') {
          if (type === 'google-app') {
            window.location.href = `/api/auth/google-app/token-redirect?token=${res?.data?.token}`;
          } else {
            await userContext.setUser({}, res?.data?.token);
            const afterOAuthRedirectUrl = localStorage.getItem('afterOAuthRedirectUrl');
            if (afterOAuthRedirectUrl) {
              localStorage.removeItem('afterOAuthRedirectUrl');
              window.location.href = afterOAuthRedirectUrl;
            } else {
              navigate('/');
            }
          }
        } else if (res?.data?.message) {
          Modal.error({
            title: res?.data?.message,
            onOk: () => navigate('/login'),
          });
        }
      })
      .catch(() => {
        Modal.error({
          title: trans('error_try_again'),
          onOk: () => navigate('/login'),
        });
      });
  }, []);
  return (
    <div
      className="page"
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <LoadingOutlined style={{ fontSize: '128px' }} />
    </div>
  );
}

export default ExternalAuth;
